import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import _ from 'underscore';
import TextDisplay from './ui/TextDisplay';
import ImageDisplay from './ui/ImageDisplay';
import ImageList from './ui/ImageList';
import LocationParentsView from './ui/LocationParentsView';
import Breadcrumb from './ui/Breadcrumb';
import TabContainer from './ui/TabContainer';
import LinkList from './ui/LinkList';
import MediaList from './ui/MediaList';
import BookmarkButton from './ui/BookmarkButton';
import LoadingBar from './ui/LoadingBar';
import MapView from './MapView';
import NotFound from './ui/NotFound';

import config from './../config';
import helpers from './../lib/helpers';

function ThingView(props) {
	const [data, setData] = useState(null);
	const [notFound, setNotFound] = useState(false);
	const [mapData, setMapData] = useState(null);
	const [loading, setLoading] = useState(true);
	const history = useHistory();

	useEffect(() => {
		if (props.match.params.id) {
			helpers.fetch(config.apiRoot+'/api/things/'+props.match.params.id, (json) => {
				if (json.notfound) {
					setNotFound(true);
					setLoading(false);

					return;
				}

				if (!helpers.isNumber(props.match.params.id) && json.id) {
					history.replace(helpers.routerUrls['orgel']+json.id);

					return;
				}
				setData(json);
				setLoading(false);
			});
		}
	}, [props.match.params.id]);

	let otherFiles = data && data.files ? _.reject(data.files, (item) => item.path.endsWith == '.jpg' || item.path.endsWith == '.png') : [];

	return <div className={'content-container position-relative '+(loading ? ' loading' : '')}>
		<LoadingBar />
		{
			notFound && <NotFound />
		}
		{
			data &&
			<React.Fragment>

				<Breadcrumb currentElTitle={data.name} />

				<div>
					<BookmarkButton id={data.id} title={data.name} type="thing" className="float-right" />
					<h2>{data.name}</h2>
				</div>

				<div className="row mt-5">

					{
						data.text && helpers.removeWhitespace(data.text).length > 0 &&
						<div className="col-12 col-md-7">
							<TextDisplay className="mt-4" maxHeight={500} text={data.text} />
						</div>
					}

					<div className={'col-12 col-md-5'}>
						{
							data.files && data.files.length > 0 && _.filter(data.files, (item) => item.path.endsWith('.jpg') || item.path.endsWith('.png')).length > 0 &&
							<ImageList data={_.filter(data.files, (item) => item.path.endsWith('.jpg') || item.path.endsWith('.png'))} />
						}

						<table className="table metadata-table">
							<tbody>
								{
									data.brand &&
									<tr><td><label>Gerð</label></td><td>{data.brand}</td></tr>
								}
							</tbody>
						</table>

						<MapView className="small mb-2"
							mapData={data.location.map((location) => {
								return {
									label: location.location.name,
									district: helpers.createLocationParentString(location.location.parent),
									id: location.location.id,
									latLng: [location.location.lat, location.location.lng]
								}
							})} />

					</div>

				</div>

				<TabContainer useRouter={'true'} selectedTab={props.match.params.tab} baseUrl={helpers.routerUrls['orgel']+props.match.params.id}>

					<div tabtitle={'Tengdir staðir'} tabname="stadir">
						<table className="table">
							<thead>
								<tr>
									<th>Nafn</th>
									<th>Tímabil</th>
								</tr>
							</thead>
							<tbody>
								{
									data.location.map((location, index) => <tr key={index}>
										<td><LocationParentsView key={index} location={location.location} /></td>
										<td>{helpers.formatDate(location.date_from)}-{helpers.formatDate(location.date_to)}</td>
									</tr>)
								}
							</tbody>
						</table>
					</div>

					{
						otherFiles && otherFiles.length > 0 &&
						<MediaList tabtitle={'Tengdar skrár'}
							tabname="skrar"
							data={otherFiles}>
							<p className="mb-3"><small>Tengdar skrár.</small></p>
						</MediaList>
					}

					{
						data && data.links && data.links.length > 0 &&
						<LinkList tabtitle={'Tenglar'}
							tabname="tenglar"
							data={data.links}>
							<p className="mb-3"><small>Tengt efni á öðrum vefjum.</small></p>
						</LinkList>
					}

				</TabContainer>

			</React.Fragment>
		}
	</div>
}

export default ThingView;
